import { Link, useLocation } from 'react-router-dom';

const breadcrumbNameMap: Record<string, string> = {
  '/': '首页',
  '/category': '产品中心',
  '/articles': '新闻资讯',
  '/about': '关于我们',
};

export default function Breadcrumb() {
  const location = useLocation();
  const pathSegments = location.pathname.split('/').filter(Boolean);

  if (pathSegments.length === 0) return null;

  const items = [
    { name: '首页', path: '/' },
    ...pathSegments.map((seg, i) => {
      const path = '/' + pathSegments.slice(0, i + 1).join('/');
      return {
        name: breadcrumbNameMap[path] || decodeURIComponent(seg),
        path,
      };
    }),
  ];

  return (
    <nav aria-label="面包屑导航" className="w-full bg-background-100/70 border-b border-background-200/50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <ol className="flex items-center gap-1.5 py-3 text-xs md:text-sm">
          {items.map((item, index) => (
            <li key={item.path} className="flex items-center gap-1.5">
              {index > 0 && (
                <i className="ri-arrow-right-s-line text-foreground-400 text-sm" />
              )}
              {index === items.length - 1 ? (
                <span className="text-foreground-600 font-medium">{item.name}</span>
              ) : (
                <Link to={item.path} className="text-foreground-400 hover:text-primary-600 transition-colors whitespace-nowrap">
                  {item.name}
                </Link>
              )}
            </li>
          ))}
        </ol>
      </div>

      <script type="application/ld+json">
        {JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'BreadcrumbList',
          itemListElement: items.map((item, index) => ({
            '@type': 'ListItem',
            position: index + 1,
            name: item.name,
            item: `https://www.zunlonggroup.com${item.path}`,
          })),
        })}
      </script>
    </nav>
  );
}